"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const luxon_1 = require("luxon");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const reducers_1 = require("../../reducers");
const getDateText = (automatedEndDate, automatedStartDate) => {
    if (automatedEndDate === '') {
        return `From ${automatedStartDate}`;
    }
    return `From ${automatedStartDate} to ${automatedEndDate}`;
};
const bullet = '\u00A0\u00A0\u2022\u00A0\u00A0';
const CampaignDurationLabel = ({ endDate, startDate, daysOfWeek, portionOfDay, }) => (React.createElement(src_1.Text, { size: "small", text: `${getDateText(endDate, startDate)}${portionOfDay && bullet}${portionOfDay}${daysOfWeek && bullet + 'On '}${daysOfWeek}`, textStyle: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
    } }));
const mapStateToProps = (state) => {
    const { startDateTime, endDateTime } = reducers_1.getEditableCampaignScheduledEventTriggerFilter(state);
    return {
        endDate: endDateTime
            ? luxon_1.DateTime.fromISO(endDateTime.date).toLocaleString({
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            })
            : '',
        startDate: luxon_1.DateTime.fromISO(startDateTime.date).toLocaleString({
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        }),
        daysOfWeek: reducers_1.getEditableCampaignDayOfWeekDisplayName(state),
        portionOfDay: reducers_1.getEditableCampaignDisplayTime(state),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, {})(CampaignDurationLabel);
